import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useParams } from "react-router-dom";
import { FETCH_STOCK_SHIPMENT_FORM_DATA } from "./graphql";
import StockShipmentFormPage from "./StockShipmentFormPage";

const StockShipmentDetailPage = () => {
  const { stockCategoryId, shipmentId } = useParams();

  const { loading, error, data } = useQuery(FETCH_STOCK_SHIPMENT_FORM_DATA, {
    variables: { id: shipmentId, stockCategoryId },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const shipment = data?.stockShipment;
  const category = data?.stockCategory;
  const transferToOptions = data?.stockCategories || [];
  const stockCategoryLatestStocks = JSON.parse(
    data?.stockCategoryLatestStocks || "[]",
  );

  const productStocks = Object.values(stockCategoryLatestStocks).reduce(
    (stocks, { product_id, latest_qty }) => ({
      ...stocks,
      [product_id]: latest_qty,
    }),
    {},
  );

  return (
    <StockShipmentFormPage
      mode="edit"
      warehouseName={category?.name || ""}
      originalShipment={shipment}
      stockCategoryId={stockCategoryId}
      productStocks={productStocks}
      transferToOptions={transferToOptions}
    />
  );
};

export default StockShipmentDetailPage;
